import React from "react";
import Head from "next/head";

import BlogContainer from "@/components/blog/blog-container";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export const BlogMomentDateFormat = "LLL";

const index = () => {
  return (
    <>
      <Head>
        <title>{seoData.BLOG.title}</title>
        <SeoMetaData data={seoData.BLOG} />
      </Head>

      <BlogContainer />
    </>
  );
};

export default index;
